<script>
  import { onMount } from 'svelte';
  import responsive from '../utils/responsive';
  import viewport from '@/js/utils/useViewportAction.js';

  import SwiperNav from '$lib/swiper/Nav.svelte';
  import { Navigation } from 'swiper';

  export let projects;
  export let light = false;
  let grow = false;

  let swiperEl,
    navPrevEl,
    navNextEl,
    innerWidth = 0;

  $: condition = innerWidth <= responsive.m;

  function handleSwiper() {
    if (innerWidth <= responsive.m) {
      Object.assign(swiperEl, {
        modules: [Navigation],
        navigation: {
          prevEl: navPrevEl,
          nextEl: navNextEl,
        },
        breakpoints: {
          0: {
            slidesPerView: 1,
          },
          600: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 3,
          },
        },
      });

      swiperEl.initialize();
    } else if (swiperEl?.swiper) {
      swiperEl.swiper.destroy();
    }
  }

  onMount(() => {
    handleSwiper();
  });

  let growline = false;
</script>

<svelte:window on:resize={handleSwiper} bind:innerWidth />

<section class="projects-wrap text-center" class:light>
  <div
    class="container container--medium"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    <h2 class="projects__title tagline">{projects.title}</h2>

    <div class="projects">
      {#if condition}
        <SwiperNav bind:prev={navPrevEl} bind:next={navNextEl} />

        <swiper-container bind:this={swiperEl} init={false}>
          {#each projects.items as item}
            <swiper-slide>
              <a class="project-item" href={item.link} target="_blank">
                <img
                  class="project-item__img"
                  src={item.logo.src}
                  width={item.logo.width}
                  height={item.logo.height}
                  alt={item.logo.alt}
                  loading="lazy"
                />
              </a>
            </swiper-slide>
          {/each}
        </swiper-container>
      {:else}
        {#each projects.items as item, i}
          {#if i != 0 && 0 == i % 5}
            <div class="line-horizontal-wrapper">
              <div
                class="line line-horizontal"
                class:growline
                use:viewport
                on:enterViewport={() => (growline = true)}
              />
            </div>
          {/if}
          {#if item.link}
            <a class="project-item" href={item.link} target="_blank">
              <img
                class="project-item__img"
                src={item.logo.src}
                width={item.logo.width}
                height={item.logo.height}
                alt={item.logo.alt}
                loading="lazy"
              />
            </a>
          {:else}
            <div class="project-item">
              <img
                class="project-item__img"
                src={item.logo.src}
                width={item.logo.width}
                height={item.logo.height}
                alt={item.logo.alt}
                loading="lazy"
              />
            </div>
          {/if}
        {/each}
      {/if}
    </div>

    <p class="text-small projects__note">{projects.note}</p>
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  @keyframes growline {
    0% {
      width: 0%;
      left: 50%;
    }

    90% {
      width: 110%;
      left: -5%;
    }

    100% {
      width: 100%;
      left: 0%;
    }
  }
  .projects-wrap {
    &.light {
      background-color: var(--aqua-3);
    }

    :global .swiper-nav {
      margin-top: -2.5rem;
    }
  }

  .projects {
    @include resp-min('m') {
      display: flex;
      flex-wrap: wrap;
    }

    position: relative;

    &__title {
      margin: 0 0 5rem;

      @include resp-max('m') {
        margin: 0;
      }
    }

    &__note {
      max-width: 58rem;
      margin: 5rem auto 0;
      color: var(--royal-light);

      @include resp-max('m') {
        margin: 0 auto;
      }
    }

    .line-horizontal {
      position: absolute;
      inset: 0;
      width: 100%;

      &.growline {
        animation: growline 2s ease-in-out;
      }

      &-wrapper {
        width: 100%;
        height: 1px;
        position: relative;
      }
    }
  }

  .project-item {
    flex: 1 1 20%;

    padding: 5rem 0 4.7rem;

    display: flex;
    align-items: center;
    justify-content: center;

    aspect-ratio: 4/3;
    transition: scale 0.3s;

    &:hover {
      scale: 1.2;
    }
  }

  body.page-template-home {
    .projects-wrap {
      .container {
        &.grow {
          animation: fade-up 1s ease-in-out backwards;
        }
      }
    }
  }
</style>
